import { Check, Lock, FileText, Gavel, Database } from "lucide-react";

const iconMap = {
  "lock": Lock,
  "database": Database,
  "file-text": FileText,
  "gavel": Gavel
};

const Methodology = ({ content }) => {
  // Default content if not loaded
  const methodContent = content || {
    section_label: "Cadena de Custodia",
    title: "Metodologia forense rigurosa",
    subtitle: "Cada paso del proceso esta documentado para garantizar la integridad de las evidencias.",
    key_points: [],
    steps: []
  };

  return (
    <section id="metodologia" className="py-24 bg-slate-800/30 relative" data-testid="methodology-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left content */}
          <div>
            <span className="text-sky-400 font-mono text-sm tracking-wider uppercase mb-4 block">
              {methodContent.section_label}
            </span>
            <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-white mb-6">
              {methodContent.title}
            </h2>
            <p className="text-slate-400 text-lg leading-relaxed mb-8">
              {methodContent.subtitle}
            </p>

            {/* Key points */}
            <div className="space-y-4">
              {methodContent.key_points?.map((point, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-sky-400/20 flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-sky-400" />
                  </div>
                  <div>
                    <h4 className="font-medium text-white">{point.title}</h4>
                    <p className="text-sm text-slate-500">{point.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Background decoration */}
            <div className="mt-12 relative">
              <img
                src="https://images.pexels.com/photos/48195/document-agreement-documents-sign-48195.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Documentacion legal"
                className="rounded-sm opacity-60 w-full h-48 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent" />
            </div>
          </div>

          {/* Right content - Timeline */}
          <div className="relative">
            <div className="timeline-line space-y-8 py-4">
              {methodContent.steps?.map((step, index) => {
                const IconComponent = iconMap[step.icon] || FileText;
                return (
                  <div key={step.id} className="relative" data-testid={`methodology-step-${step.id}`}>
                    <div className="timeline-dot" style={{ top: '6px' }} />
                    <div className="card-service">
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 rounded-sm bg-slate-900 border border-slate-700 flex items-center justify-center">
                          <IconComponent className="w-5 h-5 text-sky-400" />
                        </div>
                        <div className="flex-grow">
                          <div className="flex items-center gap-2 mb-2">
                            <span className="font-mono text-xs text-sky-400">0{step.id}</span>
                            <h3 className="font-outfit font-semibold text-white">{step.title}</h3>
                          </div>
                          <p className="text-sm text-slate-400 mb-3">{step.description}</p>
                          <ul className="flex flex-wrap gap-2">
                            {step.details?.map((detail, idx) => (
                              <li key={idx} className="text-xs px-2 py-1 bg-slate-900/50 rounded text-slate-500 border border-slate-700/50">
                                {detail}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
